import type { AddressResponse } from '~/types/global'

export const formatAddress = (
  address?: Omit<AddressResponse, 'id'> | null,
  options?: { showLines?: boolean; showCountry?: boolean }
) => {
  if (!address) return ''
  const lines =
    options?.showLines !== false
      ? [address.line1, address.line2].filter(Boolean)
      : []
  const country = options?.showCountry !== false ? (address.country ?? '') : ''
  return `${lines.join(' ')} ${address.postcode ?? ''} ${address.city ?? ''} ${country}`.trim()
}
